import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

interface BuildingOption {
  id: number;
  buildingName: string;
  buildingNumber?: number | string;
}

/**
 * Type-ahead search + multi-selectable list of buildings (groups). Pure presentation,
 * search filtering, and selection emission. Group fetching lives in the parent.
 */
@Component({
  selector: 'app-duplicate-push-group-search',
  templateUrl: './group-search.component.html',
  styleUrls: [ './group-search.component.scss' ],
})
export class DuplicatePushGroupSearchComponent {
  @Input() filteredGroups: BuildingOption[] = [];
  @Input() searchTerm = '';
  @Input() selectedGroups: BuildingOption[] = [];
  @Input() isLoading = false;

  @Output() searchChange = new EventEmitter<string>();
  @Output() groupToggled = new EventEmitter<BuildingOption>();

  onSearchInput = (event: any) => {
    const value = event?.target?.value ?? '';
    this.searchTerm = value;
    this.searchChange.emit(value);
  }

  toggleOption = (group: BuildingOption) => {
    this.groupToggled.emit(group);
  }

  isSelected = (group: BuildingOption): boolean => {
    return (this.selectedGroups || []).some((g) => Number(g.id) === Number(group.id));
  }
}
